module.exports = __webpack_public_path__ + "img/hr-electric-mining-drill-W-patch.3c26cbad.png";